import { render, staticRenderFns } from "./OTPBlockInput.vue?vue&type=template&id=e9d1e3d0&"
import script from "./OTPBlockInput.vue?vue&type=script&lang=js&"
export * from "./OTPBlockInput.vue?vue&type=script&lang=js&"
import style0 from "./OTPBlockInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports